module.exports = __webpack_public_path__ + "img/图像24.ebb59359.png";